import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatarData } from "../../../utils/solicitacoes/formatters";
import DadosFortesDesligamentoModal from "../Shared/DadosFortesDesligamentoModal";
import Campo from "../Shared/Campo";

const MOTIVO_LABELS = {
    PEDIDO_DEMISSAO: "Pedido de Demissão",
    DEMISSAO_SEM_JUSTA_CAUSA: "Demissão sem Justa Causa",
    DEMISSAO_COM_JUSTA_CAUSA: "Demissão com Justa Causa",
    TERMINO_CONTRATO_EXPERIENCIA: "Término de Contrato de Experiência",
    TERMINO_ANTECIPADO_EXPERIENCIA: "Término Antecipado de Experiência",
    TERMINO_CONTRATO_APRENDIZ: "Término de Contrato de Aprendiz",
};

const TIPO_AVISO_LABELS = {
    AVISO_TRABALHADO: "Aviso Trabalhado",
    AVISO_INDENIZADO: "Aviso Indenizado",
    SEM_AVISO: "Sem Aviso",
};

const OPCAO_DESLIGAMENTO_LABELS = {
    SUBSTITUICAO: "Substituição",
    REDUCAO_QUADRO: "Redução de Quadro",
};

const TIPO_SUBSTITUTO_LABELS = {
    INTERNO: "Interno",
    EXTERNO: "Externo",
};

// Dados acumulados do processo — sempre visível, independentemente da etapa atual.
export default function DetalheDesligamento({ detalheProcesso }) {
    const navigate = useNavigate();
    const [modalFortesAberto, setModalFortesAberto] = useState(false);
    if (!detalheProcesso) return null;

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 flex flex-col gap-4">
            {detalheProcesso.pertenceCipa === true && (
                <div className="flex items-start gap-2.5 px-3 py-2.5 bg-destructive/10 border border-destructive/30 rounded-md text-sm text-destructive">
                    <i className="fa fa-exclamation-triangle mt-0.5" />
                    <span>
                        <strong>Este funcionário pertence à CIPA.</strong> Membros da CIPA têm estabilidade provisória
                        por lei — considere isso antes de aprovar o desligamento.
                    </span>
                </div>
            )}

            <div>
                <div className="flex items-center justify-between mb-4">
                    <h2 className="font-display text-base font-semibold text-foreground">Dados do Desligamento</h2>
                    {detalheProcesso.funcionarioId && (
                        <button
                            onClick={() => setModalFortesAberto(true)}
                            className="text-xs font-medium text-primary bg-primary/10 hover:bg-primary/20 rounded-full px-2.5 py-1 inline-flex items-center gap-1.5"
                        >
                            <i className="fa fa-id-card" /> Dados do Fortes
                        </button>
                    )}
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Filial" valor={detalheProcesso.unidadeNome} />
                    <Campo label="Funcionário" valor={detalheProcesso.funcionarioNome} />
                    <Campo label="Cargo" valor={detalheProcesso.cargo} />
                    <Campo label="Motivo" valor={MOTIVO_LABELS[detalheProcesso.motivoDesligamento] || detalheProcesso.motivoDesligamento} />
                    <Campo label="Data prevista para desligamento" valor={formatarData(detalheProcesso.dataPrevistaDesligamento)} />
                    <Campo label="Tipo de Aviso" valor={TIPO_AVISO_LABELS[detalheProcesso.tipoAviso] || detalheProcesso.tipoAviso} />
                    <Campo label="Opção de Desligamento" valor={OPCAO_DESLIGAMENTO_LABELS[detalheProcesso.opcaoDesligamento] || detalheProcesso.opcaoDesligamento} />
                    <Campo label="Substituto" valor={TIPO_SUBSTITUTO_LABELS[detalheProcesso.tipoSubstituto] || detalheProcesso.tipoSubstituto} />
                    <Campo label="Pertence à CIPA" valor={detalheProcesso.pertenceCipa == null ? "Não consultado" : (detalheProcesso.pertenceCipa ? "Sim" : "Não")} />
                </div>
            </div>

            {detalheProcesso.solicitacaoPromocaoSubstitutoId && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Substituição</h3>
                    <button
                        onClick={() => navigate(`/solicitacoes/${detalheProcesso.solicitacaoPromocaoSubstitutoId}`)}
                        className="text-sm text-primary hover:underline inline-flex items-center gap-1.5"
                    >
                        <i className="fa fa-arrow-up-right-from-square text-xs" />
                        Ver solicitação de promoção vinculada (#{detalheProcesso.solicitacaoPromocaoSubstitutoNumero})
                    </button>
                </div>
            )}

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa</h3>
                <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.justificativa}</p>
            </div>

            {detalheProcesso.comentarioAprovacaoGestor && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Comentário do Gestor</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.comentarioAprovacaoGestor}</p>
                </div>
            )}

            {detalheProcesso.justificativaAnalise && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa da Análise (RH)</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.justificativaAnalise}</p>
                </div>
            )}

            <DadosFortesDesligamentoModal
                isOpen={modalFortesAberto}
                funcionarioId={detalheProcesso.funcionarioId}
                onClose={() => setModalFortesAberto(false)}
            />
        </div>
    );
} 
